/* Island finish visualizer: the product page shows only the shopper's chosen side finish and granite.
   Before anything is picked it shows the island's own combination. Photos of other colors are hidden. */
(function () {
  var dataEl = document.getElementById('island-viz-data');
  if (!dataEl) return;
  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
  if (!D || !D.prefix || !D.slides) return;

  var LOOKS = D.looks || ['plank:alpine_crest', 'plank:cindered_ash', 'plank:drifted_cypress', 'plank:midnight_graphite', 'plank:umbered_oak', 'plank:warmed_acacia',
    'plank:amber_fire_cedar', 'plank:exotic_walnut', 'plank:moonlit_gray',
    'slat_v:cindered_ash', 'slat_v:drifted_cypress', 'slat_v:umbered_oak', 'slat_v:warmed_acacia',
    'slat_h:cindered_ash', 'slat_h:drifted_cypress', 'slat_h:umbered_oak', 'slat_h:warmed_acacia',
    'stone:alabaster', 'stone:rustic_ash', 'stone:sunkissed_dune', 'stone:tuscan_hearth'];
  var GRANITES = D.granites || ['charred_onyx', 'frosted_ember', 'palisade_white', 'tempest_gray', 'gilded_ash', 'american_black'];
  var KIND = { plank: ' plank', slat_v: ' 2 inch vertical slats', slat_h: ' 2 inch horizontal slats', stone: ' stacked stone' };
  var VIEW_PART = { front: '-', back: '-back-view-', dims: '-dimensions-', life: '-patio-' };
  function words(c) { return c.split('_').map(function (w) { return w.charAt(0).toUpperCase() + w.slice(1); }).join(' '); }
  function slug(k) {
    var p = k.split(':'), c = p[1].replace(/_/g, '-');
    return { plank: c + '-plank', slat_v: c + '-vertical-slat', slat_h: c + '-horizontal-slat', stone: c + '-stone' }[p[0]];
  }
  function lookFile(view, k) { return D.prefix + VIEW_PART[view] + slug(k) + '.webp'; }
  function graniteFile(view, g) { return D.prefix + VIEW_PART[view] + g.replace(/_/g, '-') + '-granite-top.webp'; }
  function lookName(k) { var p = k.split(':'); return words(p[1]) + KIND[p[0]]; }
  var OWN = {
    front: { f: D.base_finish, g: D.base_granite }, back: { f: D.base_finish, g: D.base_granite }, dims: { f: D.base_finish, g: D.base_granite },
    life: { f: D.life_finish, g: D.life_granite }
  };

  var PLANK = { 'alpine crest': 'alpine_crest', 'cindered ash': 'cindered_ash', 'drifted cypress': 'drifted_cypress', 'midnight graphite': 'midnight_graphite', 'umbered oak': 'umbered_oak', 'warmed acacia': 'warmed_acacia', 'warm acacia': 'warmed_acacia',
    'amber fire cedar': 'amber_fire_cedar', 'exotic walnut': 'exotic_walnut', 'moonlit gray': 'moonlit_gray' };
  var STONE = { 'alabaster': 'alabaster', 'rustic ash': 'rustic_ash', 'sunkissed dune': 'sunkissed_dune', 'tuscan hearth': 'tuscan_hearth' };
  var GRAN = [['charred onyx', 'charred_onyx'], ['american black', 'american_black'], ['gilded ash', 'gilded_ash'], ['tempest gray', 'tempest_gray'], ['frosted ember', 'frosted_ember'], ['palisade white', 'palisade_white']];
  /* names as the picker shows them, for the caption */
  var SHOWN = { 'plank:warmed_acacia': 'Warm Acacia' };

  /* Qikify leaves earlier choices checked when a shopper changes their mind, so checked radios
     cannot be trusted. Read what the picker shows: the highlighted button, the highlighted
     dropdown item, or the text in the closed dropdown. */
  function clean(s) { return (s || '').replace(/\s+/g, ' ').trim(); }
  function fieldValue(re) {
    var fields = document.querySelectorAll('.tcustomizer-field');
    for (var i = 0; i < fields.length; i++) {
      var f = fields[i];
      var labEl = f.querySelector('.tcustomizer-field__heading') || f.querySelector('.tcustomizer-field__label') || f.querySelector('label');
      if (!re.test(labEl ? labEl.textContent : '')) continue;
      var act = f.querySelector('label.tcustomizer-btn--active');
      if (act) {
        var inp = act.getAttribute('for') && document.getElementById(act.getAttribute('for'));
        var v = inp && inp.value && inp.value !== '1' ? inp.value : clean(act.textContent);
        if (v) return v;
      }
      var sel = f.querySelector('.tcustomizer-dropdown-image__label.selected, .tcustomizer-dropdown__item.selected, li.selected');
      if (sel && clean(sel.textContent)) return clean(sel.textContent);
      var b = f.querySelector('.tcustomizer__dropdown-button');
      var t = b ? clean(b.textContent) : '';
      if (t && !/^select/i.test(t)) return t;
      var checked = Array.prototype.filter.call(f.querySelectorAll('input'), function (x) { return x.checked && x.value && x.value !== '1'; });
      return checked.length === 1 ? checked[0].value : null;
    }
    return null;
  }
  function finishKey(v, dir) {
    if (!v) return null;
    var s = v.toLowerCase().replace(/\s+/g, ' ').trim();
    var slat = /2 inch slat/.test(s);
    s = s.replace(/\s*2 inch slat\s*/, '').trim();
    if (slat) { var c = PLANK[s]; return c ? (dir && /horiz/i.test(dir) ? 'slat_h:' : 'slat_v:') + c : null; }
    if (PLANK[s]) return 'plank:' + PLANK[s];
    if (STONE[s]) return 'stone:' + STONE[s];
    return null;
  }
  function graniteKey(v) {
    if (!v) return null;
    var s = v.toLowerCase();
    for (var i = 0; i < GRAN.length; i++) if (s.indexOf(GRAN[i][0]) > -1) return GRAN[i][1];
    return null;
  }

  function cdn(u, w) { return u.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '') + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function srcsetFor(u) { return [400, 600, 800, 1000, 1200, 1600, 2000].map(function (w) { return cdn(u, w) + ' ' + w + 'w'; }).join(', '); }
  function fileName(u) { return (u || '').split('?')[0].split('/').pop(); }
  function abs(u) { return (u || '').replace(/^\/\//, 'https://'); }

  function slideImgs(mid) {
    return Array.prototype.slice.call(document.querySelectorAll(
      '.product-gallery__media[data-media-id="' + mid + '"] img, .product-gallery__thumbnail[data-media-id="' + mid + '"] img'));
  }
  function remember(img) {
    if (img.hasAttribute('data-viz-orig')) return;
    img.setAttribute('data-viz-orig', '1');
    img.setAttribute('data-viz-src', img.getAttribute('src') || '');
    img.setAttribute('data-viz-srcset', img.getAttribute('srcset') || '');
    img.setAttribute('data-viz-alt', img.getAttribute('alt') || '');
  }
  function restore(img) {
    if (!img.hasAttribute('data-viz-orig')) return;
    img.setAttribute('src', img.getAttribute('data-viz-src'));
    var ss = img.getAttribute('data-viz-srcset');
    if (ss) img.setAttribute('srcset', ss); else img.removeAttribute('srcset');
    img.setAttribute('alt', img.getAttribute('data-viz-alt'));
  }
  function setImgs(imgs, src, srcset, alt) {
    imgs.forEach(function (img) {
      remember(img);
      if (srcset) img.setAttribute('srcset', srcset); else img.removeAttribute('srcset');
      img.setAttribute('src', src);
      if (alt) img.setAttribute('alt', alt);
    });
  }

  /* Feedback while a new look loads: the swapped photos dim until the new image is in. */
  function busy(imgs, on) { imgs.forEach(function (img) { img.classList.toggle('viz-busy', on); }); }
  function settle(imgs, my) {
    imgs.forEach(function (img) {
      var fin = false;
      function done() { if (fin) return; fin = true; if (my === seq) img.classList.remove('viz-busy'); }
      if (img.complete && img.naturalWidth) { done(); return; }
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', done, { once: true });
      setTimeout(done, 3000);
    });
  }
  /* Composite width: what the gallery actually shows, so phones fetch less. */
  var CW = 0;
  function cw() {
    if (CW) return CW;
    var el = document.querySelector('.product-gallery__media');
    var w = (el && el.clientWidth ? el.clientWidth : 800) * (window.devicePixelRatio || 1);
    CW = Math.min(2000, Math.max(800, Math.ceil(w / 400) * 400));
    return CW;
  }

  var cache = {};
  function loadImg(u) {
    return new Promise(function (res, rej) {
      var i = new Image(); i.crossOrigin = 'anonymous';
      i.onload = function () { res(i); }; i.onerror = rej; i.src = u;
    });
  }
  function composite(body, over) {
    var key = body + '|' + over;
    if (cache[key]) return cache[key];
    cache[key] = Promise.all([loadImg(cdn(body, cw())), loadImg(cdn(over, cw()))]).then(function (r) {
      var a = r[0], b = r[1];
      var c = document.createElement('canvas');
      c.width = a.naturalWidth; c.height = a.naturalHeight;
      var x = c.getContext('2d');
      x.drawImage(a, 0, 0);
      x.drawImage(b, 0, 0, c.width, c.height);
      return new Promise(function (res) { c.toBlob(function (bl) { res(URL.createObjectURL(bl)); }, 'image/jpeg', 0.9); });
    });
    cache[key].catch(function () { delete cache[key]; });
    return cache[key];
  }
  /* Granite tops are small, so fetch them once the page is idle; a granite change then only waits on the composite. */
  var pre = false;
  function prefetch() {
    if (pre) return; pre = true;
    var views = ['front']; if (D.life) views.push('life');
    GRANITES.forEach(function (g) {
      views.forEach(function (v) { if (g !== OWN[v].g) loadImg(cdn(graniteFile(v, g), cw())).catch(function () {}); });
    });
  }

  /* Gallery roles: hero (first slide), studio front, back view, dimensions. Every other photo
     (png renders of other colors) is hidden with the theme's own carousel filter. */
  var G = { ready: false };
  function setupGallery() {
    var car = document.querySelector('.product-gallery__carousel');
    if (!car || car.getAttribute('data-viz') === '1') return;
    var cells = car.allCells || Array.prototype.slice.call(car.querySelectorAll('.product-gallery__media'));
    if (!cells.length) return;
    var front = String(D.slides.front), back = String(D.slides.back), dims = String(D.slides.dims);
    var first = cells[0].getAttribute('data-media-id');
    var hero = String(D.slides.hero || (first !== front ? first : ''));
    var photos = {}, hide = [];
    var explicit = D.hide ? D.hide.map(String) : null;
    cells.forEach(function (cell, i) {
      var mid = cell.getAttribute('data-media-id');
      var img = cell.querySelector('img');
      var name = img ? fileName(img.getAttribute('data-viz-src') || img.getAttribute('src')) : '';
      var isPhoto = /\.png$/i.test(name);
      if (isPhoto) photos[name] = 1;
      var keep = mid === hero || mid === back || mid === dims || (mid === front && D.life);
      var drop = explicit ? explicit.indexOf(mid) > -1 : (isPhoto && !keep);
      if (mid === front && !D.life && hero) drop = true;
      if (drop && mid !== hero) hide.push(i);
    });
    G = { ready: true, car: car, hero: hero, photos: photos, hide: hide };
    car.setAttribute('data-viz', '1');
    if (typeof car.filter === 'function') car.filter(hide);
    else hide.forEach(function (i) { cells[i].setAttribute('hidden', ''); });
    document.querySelectorAll('.product-gallery__thumbnail').forEach(function (th, i) { th.toggleAttribute('hidden', hide.indexOf(i) > -1); });
    layoutGrid();
  }
  function layoutGrid() {
    if (!G.ready) return;
    var car = G.car;
    var cells = Array.prototype.slice.call(car.querySelectorAll('.product-gallery__media'));
    cells.forEach(function (c) { c.classList.remove('viz-wide'); });
    var cs = getComputedStyle(car);
    var grid = cs.display === 'grid' && cs.gridTemplateColumns.split(' ').length === 2 && car.scrollWidth <= car.clientWidth + 2;
    car.classList.toggle('viz-filtered', !!grid);
    if (!grid) return;
    var vis = cells.filter(function (c) { return !c.hasAttribute('hidden'); });
    if (vis.length > 1 && (vis.length - 1) % 2 === 1) vis[vis.length - 1].classList.add('viz-wide');
  }

  function label(F, Gr) { return lookName(F) + ' with a ' + words(Gr) + ' granite top'; }
  var SHORT = { plank: ' plank', slat_v: ' vertical slats', slat_h: ' horizontal slats', stone: ' stone' };
  function shortLabel(F, Gr) { var p = F.split(':'); return (SHOWN[F] || words(p[1])) + SHORT[p[0]] + ', ' + words(Gr) + ' granite'; }

  /* Other images on the page that show this island's photos (What's Included, sticky bar). */
  function pageImgs() {
    var out = [];
    document.querySelectorAll('img').forEach(function (img) {
      if (img.closest('.product-gallery') || img.closest('.island-viz-skip')) return;
      var a = img.closest('a[href*="/products/"]');
      if (a && a.getAttribute('href').indexOf(location.pathname.split('/products/')[1] || '~') < 0) return;
      var name = fileName(img.getAttribute('data-viz-src') || img.getAttribute('src'));
      if (G.photos[name]) out.push(img);
    });
    return out;
  }

  function setCaption(text, ids) {
    var all = document.querySelectorAll('.island-viz-caption');
    for (var i = 0; i < all.length; i++) {
      var host = all[i].parentElement;
      if (!text || ids.indexOf(host && host.getAttribute('data-media-id')) < 0) all[i].remove();
    }
    if (!text) return;
    ids.forEach(function (mid) {
      var slide = document.querySelector('.product-gallery__media[data-media-id="' + mid + '"]');
      if (!slide) return;
      var cap = slide.querySelector('.island-viz-caption');
      if (!cap) {
        cap = document.createElement('div');
        cap.className = 'island-viz-caption';
        cap.setAttribute('aria-hidden', 'true');
        if (getComputedStyle(slide).position === 'static') slide.style.position = 'relative';
        slide.appendChild(cap);
      }
      cap.textContent = '';
      var pre = document.createElement('span');
      pre.className = 'island-viz-pre';
      pre.textContent = text[0];
      cap.appendChild(pre);
      cap.appendChild(document.createTextNode(text[1]));
    });
  }

  var last = null, seq = 0;
  function apply() {
    setupGallery();
    if (!G.ready) return;
    var fk = finishKey(fieldValue(/side finish/i), fieldValue(/slat direction/i));
    var gk = graniteKey(fieldValue(/counter ?top/i));
    if (fk && LOOKS.indexOf(fk) < 0) fk = null;
    if (gk && GRANITES.indexOf(gk) < 0) gk = null;
    var F = fk || D.base_finish;
    var Gr = gk || D.base_granite;
    var state = F + '|' + Gr + '|' + G.hero + '|' + (fk || gk ? 1 : 0);
    if (state === last) return;
    last = state;
    var my = ++seq;
    var desc = label(F, Gr);
    var alts = {
      front: D.island + ' in ' + desc + ', front view',
      back: 'Back of the ' + D.island + ' in ' + desc,
      dims: 'Dimensions of the ' + D.island + ' in ' + desc,
      life: D.island + ' in ' + desc + ' on a patio'
    };
    var targets = [
      { mid: D.slides.front, view: 'front', src: D.slides.front },
      { mid: D.slides.back, view: 'back', src: D.slides.back },
      { mid: D.slides.dims, view: 'dims', src: D.slides.dims }
    ];
    if (G.hero) targets.push(D.life ? { mid: G.hero, view: 'life', src: G.hero } : { mid: G.hero, view: 'front', src: D.slides.front, mirror: true });
    var extra = pageImgs();
    targets.forEach(function (t) {
      if (!t.mid) return;
      var imgs = slideImgs(t.mid);
      var srcImg = slideImgs(t.src)[0];
      if (srcImg) remember(srcImg);
      imgs.forEach(remember);
      if (t.view === 'front' && !t.mirror) { extra.forEach(remember); imgs = imgs.concat(extra); }
      if (!imgs.length || !srcImg) return;
      var own = OWN[t.view];
      var body = F === own.f ? null : lookFile(t.view, F);
      var over = Gr === own.g ? null : graniteFile(t.view, Gr);
      var origSrc = abs(srcImg.getAttribute('data-viz-src'));
      if (!body && !over) {
        if (t.mirror || t.view === 'front') {
          imgs.forEach(function (img) {
            if (img === srcImg || slideImgs(t.src).indexOf(img) > -1) restore(img);
            else setImgs([img], srcImg.getAttribute('data-viz-src'), srcImg.getAttribute('data-viz-srcset'), alts[t.view]);
          });
        } else imgs.forEach(restore);
        busy(imgs, false);
        return;
      }
      busy(imgs, true);
      if (body && !over) { setImgs(imgs, cdn(body, 2000), srcsetFor(body), alts[t.view]); settle(imgs, my); return; }
      composite(body || origSrc, over).then(function (url) {
        if (my !== seq) return;
        setImgs(imgs, url, null, alts[t.view]);
        settle(imgs, my);
      }).catch(function () { if (my === seq) busy(imgs, false); });
    });
    setCaption([fk || gk ? 'Your selection: ' : 'Shown in ', shortLabel(F, Gr)], [G.hero || String(D.slides.front)]);
  }

  var style = document.createElement('style');
  style.textContent = '.island-viz-caption{position:absolute;left:12px;bottom:12px;z-index:2;background:#fff;color:#1f2430;font-size:14px;font-weight:500;line-height:1.35;padding:6px 10px;border-radius:6px;box-shadow:0 1px 4px rgba(0,0,0,.18);pointer-events:none;width:max-content;max-width:calc(100% - 24px)}'
    + '@media (max-width:699px){.island-viz-caption{left:8px;bottom:8px;font-size:12px;padding:4px 8px;max-width:calc(100% - 16px)}.island-viz-pre{display:none}}'
    + '.product-gallery__thumbnail .island-viz-caption{display:none}'
    + '.product-gallery__carousel.viz-filtered>.product-gallery__media:not([hidden]):last-child:nth-child(even):not(.viz-wide){grid-column:span 1!important}'
    + '.product-gallery__carousel.viz-filtered>.product-gallery__media.viz-wide{grid-column:span 2!important}'
    + 'img[data-viz-orig]{transition:opacity .2s ease}img.viz-busy{opacity:.5!important}';
  document.head.appendChild(style);

  var t = null;
  function schedule() { clearTimeout(t); t = setTimeout(apply, 120); prefetch(); }
  document.addEventListener('change', schedule, true);
  document.addEventListener('click', schedule, true);
  function idle() { (window.requestIdleCallback || function (f) { setTimeout(f, 1500); })(prefetch); }
  if (document.readyState === 'complete') setTimeout(idle, 2000); else window.addEventListener('load', function () { setTimeout(idle, 2000); });
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(layoutGrid, 200); });
  setInterval(apply, 800);
  apply();
})();
